<template>
    <small>
        <p><strong>Link explanation</strong></p>
        <ul>
            <li
                v-if="!hideInternalLinkExplanation"
                :class="{
                    'mb-3': !hideExternalLinkExplanation
                }"
            >
                for
                <b-badge variant="info" class="p-1" :style="badgeStyles">
                    internal
                </b-badge>
                link, start with '/'

                <ul>
                    <li>
                        example1:
                        <strong> /about </strong>
                    </li>

                    <li>
                        example2:
                        <strong>
                            /articles/12d29dd4-6dc1-42da-9ff0-cb5efcaf854d
                        </strong>

                        <i
                            v-if="includeResourceIdTip"
                            v-b-tooltip.hover
                            class="fas fa-question-circle"
                            title="ℹ️ If resource has 'slug', be advised that if you reference resource 'id' instead of 'slug', you won't have to update all links each time you change 'slug'."
                        />
                    </li>

                    <li>
                        example3:
                        <strong> /shops/expedita-molestiae </strong>
                    </li>
                </ul>
            </li>

            <li v-if="!hideExternalLinkExplanation">
                for
                <b-badge variant="info p-1" :style="badgeStyles">
                    external
                </b-badge>
                link, start with 'http(s)'

                <ul>
                    <li>
                        example1:
                        <strong>https://sequelize.org</strong>
                    </li>

                    <li>
                        example2:
                        <strong>https://www.sequelize.org</strong>
                    </li>
                </ul>
            </li>
        </ul>
    </small>
</template>

<script>
export default {
    props: {
        hideInternalLinkExplanation: {
            type: Boolean,
            required: false,
            default: false
        },

        hideExternalLinkExplanation: {
            type: Boolean,
            required: false,
            default: false
        },

        includeResourceIdTip: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            badgeStyles: {
                fontSize: '11px'
            }
        };
    },

    mounted() {
        if (
            this.hideExternalLinkExplanation &&
            this.hideInternalLinkExplanation
        ) {
            throw 'Consider removing `LinkExplanation` component since it does not display anything 😢.';
        }
    }
};
</script>
